import gql from 'graphql-tag';

const BULK_GROUP_ENROLLMENT_ACTION = gql`
  mutation bulkGroupEnrollmentAction($data: [BulkGroupEnrollmentActionInput!]!) {
    bulkGroupEnrollmentAction(data: $data) {
      groupEnrollment {
        id
        studentId
        groupId
      }
      error
    }
  }
`;

export default BULK_GROUP_ENROLLMENT_ACTION;
